import { useState } from 'react';
import { Box, Typography } from '@mui/material';
import { DatabaseIcon } from 'lucide-react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { AnalysisDataExtractionJobs } from './AnalysisDataExtractionJobs';
import { WeeklyStoreProductGroupForm } from './WeeklyStoreProductGroupForm';
import type { SimpleAccount } from '@/lib/types';

interface AnalysisDataExtractionProps {
  account: SimpleAccount;
}

/**
 * 分析用データ取得タブのコンテンツ
 * 「[週次/月次] 店舗×商品グループ実績抽出」の実行・実行ログをサブタブで切り替える
 */
export function AnalysisDataExtraction({ account }: AnalysisDataExtractionProps) {
  // 実行受付後に実行ログタブへ切り替えるため、タブを制御する
  const [activeTab, setActiveTab] = useState('run');

  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="h5" sx={{ mb: 3, display: 'flex', alignItems: 'center' }}>
        <DatabaseIcon size={24} style={{ marginRight: 8 }} />
        [週次/月次] 店舗×商品グループ実績抽出
      </Typography>

      <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
        <TabsList className="grid w-full grid-cols-2">
          <TabsTrigger value="run">実行</TabsTrigger>
          <TabsTrigger value="logs">実行ログ</TabsTrigger>
        </TabsList>

        <TabsContent value="run" className="mt-6">
          <WeeklyStoreProductGroupForm account={account} onSubmitted={() => setActiveTab('logs')} />
        </TabsContent>

        <TabsContent value="logs" className="mt-6">
          <AnalysisDataExtractionJobs account={account} />
        </TabsContent>
      </Tabs>
    </Box>
  );
}
